import * as actionType from "./ActionTypes";
import { findIndex } from "lodash";

export default function InvoicePackingEmailReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.INVOICEPACKING_EMAIL_DATA:
      return (state = payload);
    case actionType.UPDATE_INVOICEPACKING_EMAIL_DATA_TRACTOR:
      for (let i = 0; i < payload.data.length; i++) {
        const findId = findIndex(state, (data) => {
          return (
            data.ContainerMasterId ===
            parseInt(payload.data[i].ContainerMasterId)
          );
        });
        state[findId] = {
          ...payload.data[i],
          isInvEmailSentTractor: payload.isInvEmailSentTractor === 1 ? 1 : 0,
        };
      }
      return state;
    case actionType.UPDATE_INVOICEPACKING_EMAIL_DATA_AGGREGATE:
      for (let i = 0; i < payload.data.length; i++) {
        const findId = findIndex(state, (data) => {
          return (
            data.ContainerMasterId ===
            parseInt(payload.data[i].ContainerMasterId)
          );
        });
        state[findId] = {
          ...payload.data[i],
          isInvEmailSentAggregate: payload.isInvEmailSentAggregate === 1 ? 1 : 0,
        };
      }
      return state;
    case actionType.UPDATE_INVOICEPACKING_EMAIL_DATA_5M:
      for (let i = 0; i < payload.data.length; i++) {
        const findId = findIndex(state, (data) => {
          return (
            data.ContainerMasterId ===
            parseInt(payload.data[i].ContainerMasterId)
          );
        });
        state[findId] = {
          ...payload.data[i],
          isInvEmailSent5M: payload.isInvEmailSent5M === 1 ? 1 : 0,
        };
      }
      return state;
    default:
      return state;
  }
}
